<template>
  <div class="d-flex align-center">
    <v-text-field
      v-model.lazy="meetingAmount"
      v-money="catalogCurrency()"
      @input="handleSetAmount"
      :label="$t('appointment.formCreate.labels.displacementAmount')"
      :rules="[rules.cantBeNegative]"
      class="amount inputAmount mr-2"
      hide-details="auto"
      ref="meetingAmount"
      type="tel"
      outlined
    />
    <InformationTooltip
      :message="$t('appointment.formCreate.hints.displacement')"
    />
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import { catalogCurrency } from '@/util/catalog'
import { clearCurrency } from '@/util/helpers'
import { cantBeNegative } from '@/util/errorHandling'
import { VMoney } from 'v-money'

import InformationTooltip from '@/components/app/InformationTooltip'
import HAmount from '@/components/app/HAmount'

export default {
  name: 'MeetingAmount',

  components: {
    HAmount,
    InformationTooltip,
  },

  directives: {
    money: VMoney
  },

  data() {
    return {
      _timer: null,
      catalogCurrency,
      meetingAmount: 0,
      rules: {
        cantBeNegative,
      },
    }
  },

  methods: {
    ...mapActions(['getAppointmentAmount']),
    ...mapMutations(['setAppointmentFields']),

    handleSetAmount() {
      clearTimeout(this._timer)
      const amount = clearCurrency(this.meetingAmount);

      this._timer = setTimeout(() => {
        this.setAppointmentFields({ displacement: amount })
        this.getAppointmentAmount()
      }, 500)
    },

    resetValue() {
      this.meetingAmount = 0

      const meetingAmount = this.$refs?.meetingAmount?.$refs?.input
      meetingAmount.value = '0.00'
    }
  },
}
</script>
